const keywords = [
	"Genius Tutoring Group",
	"Municipalidad de Mora",
	"Arturo García Rodríguez",
	"Arturo",
];

const SEO = [
	{
		page: "home",
		description:
			"My current strength lies in creating native mobile applications for both Android and iOS, using cutting-edge technologies to enable innovation. I have also worked on projects that require diverse technical skills, such as creating databases, servers, web applications, and automation using various programming languages.",
		keywords: keywords,
	},

	{
		page: "about",
		description:
			"I have worked on a variety of projects; some in the private sector and others in the public sector. Part of the private projects involved the creation of Genius Tutoring Group, a company that will be launched in 2024, for which I was responsible for creating all the necessary technology, such as databases, servers, web and mobile applications, among other tasks. Additionally, I collaborated with a local government in the creation of a planning system that helped optimize 80% of the time spent on these tasks.",
		keywords: keywords,
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: keywords,
	},

	{
		page: "contact",
		description:
			"You can contact me with the email: arturotphx@gmail.com or arturo@geniustutoringgroup.com",
		keywords: keywords,
	},
];

export default SEO;
